import { VvDialog } from '@volverjs/ui-vue/components'
import { defineComponent, h, nextTick, ref, type VNode } from 'vue'

type DialogProps = {
    title?: string
    transition?: string
    modifiers?: string | string[]
    /** @deprecated use modifiers instead */
    size?: 'small' | 'standard' | 'fullscreen'
    role?: 'alert' | 'alertdialog'
    keepOpen?: boolean
}

type DialogSlots = {
    footer?: () => VNode | string
    header?: () => VNode | string
    default?: () => VNode | string | VNode[] | string[]
}

const isOpen = ref(false)
const title = ref<DialogProps['title']>()
const transition = ref<DialogProps['transition']>()
const modifiers = ref<DialogProps['modifiers']>()
const size = ref<DialogProps['size']>()
const keepOpen = ref<DialogProps['keepOpen']>(false)
const role = ref<DialogProps['role']>()
const slots = ref<DialogSlots>()

export const useDialog = () => {
    const onUpdateModelValue = (value: boolean) => {
        isOpen.value = value
    }

    const onAfterLeave = () => {
        title.value = undefined
        transition.value = undefined
        modifiers.value = undefined
        size.value = undefined
        keepOpen.value = undefined
        role.value = undefined
        slots.value = undefined
    }

    const PkGlobalDialog = defineComponent({
        name: 'PkGlobalDialog',
        render: () =>
            h(
                VvDialog,
                {
                    modelValue: isOpen.value,
                    title: title.value,
                    transition: transition.value,
                    modifiers: modifiers.value,
                    size: size.value,
                    keepOpen: keepOpen.value,
                    role: role.value,
                    'onUpdate:modelValue': onUpdateModelValue,
                    onAfterLeave: onAfterLeave,
                },
                slots.value,
            ),
    })

    const openDialog = (newProps: DialogProps, newSlots?: DialogSlots) => {
        title.value = newProps?.title
        transition.value = newProps?.transition
        modifiers.value = newProps?.modifiers
        size.value = newProps?.size
        keepOpen.value = newProps?.keepOpen ?? false
        role.value = newProps?.role
        slots.value = newSlots
        nextTick(() => {
            isOpen.value = true
        })
        return isOpen
    }

    return { PkGlobalDialog, openDialog, isOpen }
}
